import _ from "lodash"
import jMoment from 'jalali-moment'

export default {
	template: `
    <div class="p-3 form-container">
    <!--        <nk-dropdown class="mb-3" :data="types" :options="{multiSelection:false}" v-model="selectedType"></nk-dropdown>-->
    <select class="mb-3 p-1 w-100 m-dropdown-input.selected-items" v-on:change="handleSelectedOption">
      <option class="item " v-for="item in types" :value="item.id">{{ item.name }}</option>
    </select>
    <nk-input :options="settings.inputOptions" v-model="filterText" @update:modelValue="(value)=>this.filterText=value" />

    </div>
	`,
	props: {
		options: { type: Object }
	},
	data: function () {
		const types = [
			{ id: 'contains', func: 'isInclude', name: 'شامل شود' },
			{ id: 'equals', func: 'isSame', name: 'برابر با' },
			{ id: 'greaterThan', func: 'isAfter', name: 'بزرگتر از' },
			{ id: 'lessThan', func: 'isBefore', name: 'کوچکتر از' },
		]
		return {
			filterText: null,
			selectedType: types[0],
			types: types,
			timer: null,
			settings: {
				debounceMs: 0,
				inputOptions: {
					mode: 'price',
				}
			},
		}
	},
	mounted() {
		this.settings = _.merge(this.settings, this.params.options)
		this.settings.debounceMs = this.params.debounceMs
		this.settings.selectedType && (this.selectedType = this.settings.selectedType)
	},
	watch: {
		filterText(newFilterText, oldFilterText) {
			this.applyFilter()
		},
	},
	methods: {
		applyFilter() {
			if (this.timer)
				clearTimeout(this.timer)

			this.timer = setTimeout(() => {
				this.params.filterChangedCallback()
			}, this.settings.debounceMs)
		},
		isFilterActive() {
			return (
				this.filterText !== null &&
				this.filterText !== 0 &&
				this.filterText !== undefined &&
				this.filterText !== ''
			)
		},
		handleSelectedOption(event) {
			// console.log(event.target.value)
			this.selectedType = this.types.find(x => x.id == event.target.value)
			if (this.filterText) this.params.filterChangedCallback()
		},
		doesFilterPass(params) {
			let value = this.params.valueGetter(params)
			let valueFormatted = this.params?.colDef.valueFormatter({ ...params, value: value })
			const functions = {
				contains: (value) => String(value).includes(this.filterText),
				equals: (value) => parseFloat(this.filterText) === value,
				greaterThan: value => parseFloat(this.filterText) <= value,
				lessThan: value => parseFloat(this.filterText) >= value,
			}
			if (this.isFilterActive()) {
				if (!valueFormatted && valueFormatted) return false
				if (typeof valueFormatted === 'string' && /^-?\d+(?:[.,]\d+)*$/.exec(valueFormatted))
					valueFormatted = valueFormatted.replace(/[^0-9.-]+/g, "")
				valueFormatted = parseFloat(valueFormatted)
				return functions[this.selectedType?.id](this.params.colDef.valueFormatter ? valueFormatted : value)
			}
		},

		isNumeric(n) {
			return !isNaN(parseFloat(n)) && isFinite(n)
		},

		getModel() {
			return {
				filter: this.filterText,
				filterType: "price",
				type: this.selectedType.id
			}
		},

		setModel(model) {
			this.filterText = model.filter
			this.selectedType = this.types.find(x => x.id === model.type)
		},

		myMethodForTakingValueFromFloatingFilter(value) {
			this.filterText = value
		},
	},
}
